import { FormProvider, useForm } from 'react-hook-form'
import React, { useState } from 'react'
import { Button } from 'antd'
import Heading from 'components/Heading'
import NavigationTab from 'components/NavigationTabs'
import RobBunkerTab from './tabs/RobBunkerTab'
import RobFuelTanksTab from './tabs/RobFuelTanksTab'
import RobGeneralTab from './tabs/RobGeneralTab'
import robPermissions from 'constants/robPermissions'
import RobSludgeOilBilgeTab from './tabs/RobSludgeOilBilgeTab'
import { robSurveyDefaultValues } from './robSurveyDefaultValues'
import { robSurveySchema } from './robSurveySchema'
import usePermission from 'hooks/usePermission'
import { useTranslation } from 'react-i18next'
import withLayout from 'components/layout'
import { zodResolver } from '@hookform/resolvers/zod'

import '../../global/styles/global.less'
import './robSurvey.less'

const getRobSurveyTabs = t => [
  { key: 'general', label: t('rob.survey.tabs.general') },
  { key: 'bunker', label: t('rob.survey.tabs.bunker') },
  { key: 'fuelTanks', label: t('rob.survey.tabs.fuelTanks') },
  { key: 'sludgeOilBilge', label: t('rob.survey.tabs.sludgeOilBilge') },
]

const TAB_CONTENT = {
  bunker: <RobBunkerTab />,
  fuelTanks: <RobFuelTanksTab />,
  general: <RobGeneralTab />,
  sludgeOilBilge: <RobSludgeOilBilgeTab />,
}

const RobSurvey = () => {
  const { t } = useTranslation()
  const can = usePermission()
  const tabs = getRobSurveyTabs(t)
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const methods = useForm({
    defaultValues: robSurveyDefaultValues,
    resolver: zodResolver(robSurveySchema),
  })

  const onSubmit = data => {
    // TODO: handle survey submission
    console.log(data)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="page__container">
          <div className="rob-survey__header">
            <Heading level={2}>{t('rob.survey.title')}</Heading>
            {can(robPermissions.SUBMIT_SURVEY) && (
              <Button htmlType="submit" type="primary">
                {t('rob.survey.submitSurveyButton')}
              </Button>
            )}
          </div>
          <NavigationTab
            activeKey={activeTab}
            className="rob-survey__tabs"
            items={tabs}
            onTabChange={setActiveTab}
          />
          {Object.entries(TAB_CONTENT).map(([key, content]) => (
            <div
              key={key}
              style={key !== activeTab ? { display: 'none' } : undefined}
            >
              {content}
            </div>
          ))}
        </div>
      </form>
    </FormProvider>
  )
}

export default withLayout(RobSurvey)
